export const TRATAMIENTO_DATOS = 'Autorizo el tratamiento de mis datos personales de acuerdo a la';
export const TRATAMIENTO_DATOSFinal = 'de la información de la Caja de Compensación Familiar Comfenalco Valle Delagente';
